/**
 * Mangles and concatenates CSS class name using BEM naming conventions.
 *
 * @param blockName BEM block name.
 * @param [elementName] BEM element name.
 * @param [modifierName] BEM modifier name.
 * @returns BEM CSS class name.
 */
export const bemClassName = (
    blockName: string,
    elementName?: string,
    modifierName?: string
): string => {
    const tidyBlock = tidyBemPart(blockName);
    if (!tidyBlock) {
        return "";
    }
    const tidyElement = elementName ? tidyBemPart(elementName) : "";
    const tidyModifier = modifierName ? tidyBemPart(modifierName) : "";
    const separatedElement = tidyElement ? `__${tidyElement}` : "";
    const separatedModifier = tidyModifier ? `--${tidyModifier}` : "";
    const bemClassNameName = tidyBlock
        ? `${tidyBlock}${separatedElement}${separatedModifier}`
        : "";
    return bemClassNameName;
};

/**
 * Tidy BEM name part.
 * @param rawPart Raw BEM name part.
 * @returns Tidy BEM name part.
 */
export const tidyBemPart = (rawPart: string): string =>
    rawPart
        ? rawPart
              .toLowerCase()
              .replace(/[-]{2,}/g, "-")
              .replace(/([-\d]*)([-a-z\d]+)/g, "$2")
              .replace(/([-a-z\d]+)([-]+$)/g, "$1")
        : "";
